import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { TrackerLayout } from './TrackerLayout';
import { TypePie, TierBars, WeeklyLines } from './TrackerCharts';
import { PostList } from './PostList';
import { trackerGet, CARD, compact, dateTime, errMsg } from './trackerApi';

const Panel = ({ title, children, testid, className = '' }) => (
  <div className={`${CARD} p-6 ${className}`} data-testid={testid}>
    <h2 className="text-sm font-semibold mb-3">{title}</h2>
    {children}
  </div>
);

const Detail = ({ handle }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { setD(null); trackerGet(`/competitors/${handle}`).then(setD).catch((e) => setErr(errMsg(e, 'Could not load competitor'))); }, [handle]);
  if (err) return <p className="text-sm text-[#6B6B6B]" data-testid="competitor-detail-error">{err}</p>;
  if (!d) return <Loader2 className="animate-spin text-[#FF451A]" size={18} />;
  const c = d.competitor;
  return (
    <div className="space-y-5" data-testid="competitor-detail">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-3xl font-bold tracking-tight" data-testid="competitor-detail-name">{c.name}</h2>
          <a href={`https://www.instagram.com/${c.instagram_handle}/`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#FF451A] hover:underline">@{c.instagram_handle}</a>
        </div>
        <div className="flex items-center gap-6 text-sm">
          <div><span className="font-bold text-lg">{d.post_count}</span> <span className="text-[#71717A]">posts</span></div>
          <div><span className="font-bold text-lg">{compact(d.total_reach)}</span> <span className="text-[#71717A]">reach</span></div>
          <div><span className="font-bold text-lg text-[#FF451A]">{d.avg_er ?? '—'}%</span> <span className="text-[#71717A]">avg ER</span></div>
          <div><span className="font-bold text-lg">{d.paid_count}</span> <span className="text-[#71717A]">paid collabs</span></div>
        </div>
      </div>
      <div className="text-xs text-[#71717A]" data-testid="competitor-last-updated">Last updated: {dateTime(d.last_updated)}</div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <Panel title="Content type" testid="competitor-type-chart"><TypePie split={d.type_split} /></Panel>
        <Panel title="Creator tiers" testid="competitor-tier-chart"><TierBars split={d.tier_split} /></Panel>
        <Panel title="Posting frequency · last 4 weeks" testid="competitor-weekly-chart"><WeeklyLines data={d.weekly} competitors={[c]} height={220} /></Panel>
      </div>
      <Panel title={`Posts (${d.posts.length})`} testid="competitor-posts-panel"><PostList posts={d.posts} testid="competitor-posts" /></Panel>
    </div>
  );
};

export default function CompetitorDetail() {
  const { handle } = useParams();
  return (
    <TrackerLayout title="Competitor detail" actions={<Link to="/brand/competitors" className="text-sm text-[#71717A] hover:text-[#FF451A] inline-flex items-center gap-1 transition-colors" data-testid="competitor-back"><ArrowLeft size={14} /> All competitors</Link>}>
      {() => <Detail handle={handle} />}
    </TrackerLayout>
  );
}
